import PropTypes from 'prop-types';
import {
    FormattedMessage
} from 'react-intl';
import React from 'react';
import './SegmentedRadio.css';
import bindAll from 'lodash.bindall';
import { Radio } from 'antd';
import camera from './assets/icon-camera.png'
import device from './assets/icon-device.png'
import monitor from './assets/icon-monitor.png'
// import python from './icon-python.png'


class SegmentedRadio extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'setActiveIndex',
            'onInputChange',
            // 'onUpdateStyle'
        ]);
        this.state = {
            activeIndex: 0,
            defaultValueRadio: 'device'
        };
        this.componentReady = React.createRef();
    }

    componentDidMount() {
        this.componentReady.current = true;
        // this.onUpdateStyle();
    }

    shouldComponentUpdate(nextProps, nextState) {
        // activeIndex, callback, controlRef, segments
        return (
            // this.state.activeIndex !== nextState.activeIndex ||
            // this.props.callback !== nextProps.callback ||
            // this.props.controlRef !== nextProps.controlRef ||
            // this.props.segments !== nextProps.segments
            this.state.defaultValueRadio !== nextState.defaultValueRadio ||
            this.props.callback !== nextProps.callback
        );
    }

    componentDidUpdate() {
        // this.onUpdateStyle();
    }

    componentWillUnmount() {
        // recycle the DOM nodes
        this.props.segments.forEach(segment => {
            segment.ref.current.remove();
        });
        this.componentReady = null;
    }

    setActiveIndex(defaultIndex) {
        this.setState({
            defaultValueRadio: defaultIndex
        })
        this.forceUpdate()
    }

    onInputChange(e) {
        this.setState({
            defaultValueRadio: e.target.value
        })
        this.props.callback(e.target.value);
        this.forceUpdate()
    }

    onUpdateStyle() {
        // const activeSegmentRef = this.props.segments[this.state.activeIndex].ref;
        // const {offsetWidth, offsetLeft} = activeSegmentRef.current;
        // const {style} = this.props.controlRef.current;
        // style.setProperty('--highlight-width', `${offsetWidth}px`);
        // style.setProperty('--highlight-x-pos', `${offsetLeft}px`);
    }


    render() {
        const {
            name,
        } = this.props;
        return (
            <div
                className="controlsContainer"
                ref={this.props.controlRef}
            >
                <div className="controls">
                    <Radio.Group
                        value={this.state.defaultValueRadio}
                        buttonStyle="solid"
                        className="radioGroup"
                        onChange={(e) => {
                            this.onInputChange(e)
                        }}>
                        {/* <Radio.Button value="camera">
                            <div className="radioButton">
                                <div className="radioImg">
                                    <img
                                        height="30"
                                        width="30"
                                        src={camera}
                                    />
                                </div>
                                <div>
                                    <FormattedMessage
                                        defaultMessage="Image"
                                        description="Image"
                                        id="gui.homePage.camTitle"
                                    />
                                </div>
                            </div>
                        </Radio.Button> */}
                        <Radio.Button value="device">
                            <div className="radioButton">
                                <div className="radioImg">
                                    <img
                                        height="27"
                                        width="34"
                                        src={device}
                                    />
                                </div>
                                <div>
                                    <FormattedMessage
                                        defaultMessage="Equipment"
                                        description="Equipment"
                                        id="gui.homePage.deviceTitle"
                                    />
                                </div>
                            </div>
                        </Radio.Button>
                        <Radio.Button value="monitor">
                            <div className="radioButton">
                                <div className="radioImg">
                                    <img
                                        height="27"
                                        width="34"
                                        src={monitor}
                                    />
                                </div>
                                <div>
                                    <FormattedMessage
                                        defaultMessage="Variable"
                                        description="Variable"
                                        id="gui.homePage.monitorTitle"
                                    />
                                </div>
                            </div>
                        </Radio.Button>
                    </Radio.Group>
                </div>
            </div>
        );
    }
}

SegmentedRadio.defaultProps = {
    callback: () => { },
    controlRef: React.createRef(),
    segments: []
};

SegmentedRadio.propTypes = {
    name: PropTypes.string,
    // segments: PropTypes.arrayOf(PropTypes.shape({
    //     value: PropTypes.string,
    //     label: PropTypes.string,
    //     ref: PropTypes.oneOfType([
    //         PropTypes.func,
    //         PropTypes.shape({current: PropTypes.instanceOf(Element)})
    //     ])
    // })),
    callback: PropTypes.func,
    defaultIndex: PropTypes.number,
    controlRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
};

export default SegmentedRadio;
